
export type TweetFeedResponseTweetsItemStats = {
  likes?: number;
  replies?: number;
  retweets?: number;
  views?: number;
};
